import { useContext } from 'react';
import AvailabilityAction from '~/constants/availabilityAction';
import PrimaryCtaType from '~/constants/PrimaryCtaType';
import SecondaryCtaType from '~/constants/SecondaryCtaType';
import {
  useIsCampaignTemplateOne,
  useIsCampaignTemplateThree,
  useIsCampaignTemplateTwo
} from '~/context/vdp/StaticContext';
import { UserVehicleContext } from '~/context/vdp/UserVehicleContext';
import usePrimaryCtaButtonState from '~/hooks/vdp/selectors/usePrimaryCtaButtonState';
import useIsPurchasableOrOnHold from './useIsPurchasableOrOnHold';

// REO-4435 - Update reserved by user + logged out => SecondaryCtaType.ViewSimilarVehicles
export default function useSecondaryCtaButtonState() {
  const {
    isSubscribedToNotifications,
    vehicleAvailability: {
      data: { action },
      isLoaded
    }
  } = useContext(UserVehicleContext);
  const isCampaignTemplateOne = useIsCampaignTemplateOne();
  const isCampaignTemplateTwo = useIsCampaignTemplateTwo();
  const isCampaignTemplateThree = useIsCampaignTemplateThree();
  const isPurchasableOrOnHold = useIsPurchasableOrOnHold();
  const { type: primaryCtaType } = usePrimaryCtaButtonState();

  const notifyMe =
    action === AvailabilityAction.NotifyMe && !isSubscribedToNotifications;

  const preOrderNow = primaryCtaType === PrimaryCtaType.Reservable;

  // button state logic
  const getAlerts = preOrderNow && !isSubscribedToNotifications;
  const isEligibleCampaignTemplateTwoOrThree =
    (isCampaignTemplateTwo || isCampaignTemplateThree) && isPurchasableOrOnHold;
  const viewMoreCars =
    primaryCtaType === PrimaryCtaType.GetAlerts ||
    (primaryCtaType === PrimaryCtaType.GetStarted &&
      (isCampaignTemplateOne || isEligibleCampaignTemplateTwoOrThree));

  const type = (() => {
    switch (true) {
      case !isLoaded:
        return SecondaryCtaType.Default;
      case notifyMe:
        return SecondaryCtaType.NotifyMe;
      case getAlerts:
        return SecondaryCtaType.GetAlerts;
      case viewMoreCars:
        return SecondaryCtaType.ViewMoreCars;
      default:
        return SecondaryCtaType.Default;
    }
  })();

  return {
    type
  };
}
